import { ActionCreator, createAction, props, Action } from '@ngrx/store';

import {RequestBodyModel} from '@app/models/client/request-body.model';

export enum Types {
  UPDATE_SEARCH_QUERY = '[SEARCH_QUERY] Update: Start',
}

export const UpdateSearchQuery: ActionCreator<
  Types.UPDATE_SEARCH_QUERY,
  (props: { searchQuery: RequestBodyModel }) => {
    searchQuery: RequestBodyModel;
  } & Action<Types.UPDATE_SEARCH_QUERY>
  > = createAction(
  Types.UPDATE_SEARCH_QUERY,
  props<{ searchQuery: RequestBodyModel }>()
);
